import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PeripheralsService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  // Passing the peripheral id from peripheral management component to device history component
  peripheralIds = new BehaviorSubject<number[]>([]);
  getPeripheralsDetails(body: any): Observable<any> {
    const apiUrl = `${this.apiUrl}/peripherals/v1/peripherals/search`;
    return this.http.post(apiUrl, body);
  }

  deletePeripheral(id: number): Observable<any> {
    const url = `${this.apiUrl}/peripherals/v1/sensor/${id}`;
    return this.http.delete(url);
  }

  //  getPeripheralsByDeviceId(id:any,page:number,size:number){
  //     const headers = new HttpHeaders({
  //       'accept': '*/*',
  //       'Content-Type': 'application/json',
  //     });
  //     let url = `http://74.179.58.105:8080/api/peripherals/v1/sensor/device/${id}?page=${page}&size=${size}`;

  //     return this.http.get(url, { headers });

  //   }
}
